import { ISLANDS } from "../../content/islands";
import { ASSETS } from "../../lib/assets";
import { useI18n } from "../../i18n/I18nProvider";

function IslandButton({ isl, dim, onSelect, active }) {
  const { t } = useI18n();
  const Icon = isl.icon;
  const [name, desc] = t(`islands.${isl.id}`);
  return (
    <button
      type="button" data-testid={`island-${isl.id}`} onClick={() => onSelect(isl.id)} aria-label={`${name}: ${desc}`} aria-pressed={active}
      className={`group absolute -translate-x-1/2 -translate-y-1/2 transition-[opacity,transform] duration-300 focus-visible:scale-110 ${dim ? "opacity-35" : "opacity-100"} hover:scale-110 ${active ? "scale-110" : ""}`}
      style={{ left: `${isl.x}%`, top: `${isl.y}%` }}>
      <span className="flex flex-col items-center">
        <span className="island-base relative grid h-[clamp(64px,8vw,104px)] w-[clamp(76px,9.5vw,124px)] place-items-center shadow-[0_18px_30px_-10px_rgba(18,62,145,.45)] ring-4 ring-white/80 transition-shadow group-hover:shadow-[0_24px_40px_-8px_rgba(255,184,46,.7)]"
          style={{ background: `radial-gradient(circle at 30% 25%, rgba(255,255,255,.65), transparent 40%), linear-gradient(160deg, ${isl.from}, ${isl.to})` }}>
          <Icon className="h-[clamp(26px,3vw,40px)] w-[clamp(26px,3vw,40px)] text-white drop-shadow" aria-hidden />
          <span className="absolute -bottom-2 left-1/2 h-3 w-3/4 -translate-x-1/2 rounded-[50%] bg-[#123E91]/15 blur-sm" aria-hidden />
        </span>
        <span className="mt-2 whitespace-nowrap rounded-full bg-white/95 px-3 py-1 font-heading text-[clamp(11px,1vw,14px)] font-extrabold text-[#17345F] shadow-md">{name}</span>
      </span>
    </button>
  );
}

export function WorldMap({ onSelect, activeId, visible }) {
  return (
    <div data-testid="world-map" className="relative hidden aspect-[16/9] w-full overflow-hidden rounded-[36px] border-4 border-white shadow-2xl md:block">
      <img src={ASSETS.world.src} alt={ASSETS.world.alt} width={1280} height={720} className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-b from-white/55 via-white/35 to-[#EAF7FF]/70" aria-hidden />
      <svg className="absolute inset-0 h-full w-full" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden>
        <path d="M14 30 Q25 10 36 18 T60 26 T84 20 M14 30 Q12 55 20 70 T44 62 T66 72 T86 58 M60 26 Q52 45 44 62 M84 20 Q90 40 86 58" fill="none" stroke="#fff" strokeWidth=".5" strokeDasharray="1.2 1.2" opacity=".9" />
      </svg>
      {ISLANDS.map((isl) => <IslandButton key={isl.id} isl={isl} dim={visible && !visible.includes(isl.id)} active={activeId === isl.id} onSelect={onSelect} />)}
    </div>
  );
}

export function IslandGrid({ onSelect, visible, forceShow = false }) {
  const { t } = useI18n();
  return (
    <ul data-testid="island-grid" className={`grid grid-cols-2 gap-3 sm:grid-cols-3 ${forceShow ? "md:grid-cols-4" : "md:hidden"}`}>
      {ISLANDS.filter((i) => !visible || visible.includes(i.id)).map((isl) => {
        const Icon = isl.icon;
        const [name, desc] = t(`islands.${isl.id}`);
        return (
          <li key={isl.id}>
            <button data-testid={`island-card-${isl.id}`} onClick={() => onSelect(isl.id)} className="card-float flex h-full w-full flex-col items-start gap-2 rounded-[24px] bg-white p-4 text-left">
              <span className="island-base grid h-12 w-14 place-items-center" style={{ background: `linear-gradient(160deg, ${isl.from}, ${isl.to})` }}><Icon className="h-6 w-6 text-white" /></span>
              <span className="font-heading font-extrabold text-[#17345F]">{name}</span>
              <span className="text-xs text-[#17345F]/65">{desc}</span>
            </button>
          </li>
        );
      })}
    </ul>
  );
}
